import { createRouter, createWebHistory } from 'vue-router'
import {getIsMobile} from "@/js/common";

const importComponent = (componentPath) => {
  if (getIsMobile()){
    return () => import('@/views/mobile/' + componentPath)
  } else {
    return () => import('@/views/pc/' + componentPath)
  }
}
const routes = [
  {
    path: '/',
    name: 'home',
    component: importComponent('HomeView')
  },
  {
    path: '/free-robux-giveaway',
    name: 'giveAway',
    component: importComponent('GiveAway')
  },
  {
    path: '/free-robux-giveaway/:name',
    name: 'giveAwayName',
    component: importComponent('GiveAway')
  },
  {
    path: '/share/:ref',
    name: 'homeShare',
    component: importComponent('HomeShareView')
  },
  {
    path: '/:userId/account',
    name: 'userBackend',
    component: importComponent('UserBackend')
  },
  {
    path: '/lp',
    name: 'lp',
    component: importComponent('Lp')
  },
  {
    path: '/lp:num([1-3])',
    name: 'lp-num',
    component: importComponent('LpNum')
  },
  {
    path: '/lp4',
    name: 'lp4',
    component: importComponent('Lp4')
  },
  {
    path: '/install-success',
    name: 'install',
    component: importComponent('Install')
  },
  {
    path: '/uninstall',
    name: 'uninstall',
    component: importComponent('Uninstall')
  },
  {
    path: '/join/:shareParam',
    name: 'share',
    component: importComponent('Share')
  },
  {
    path: '/policy',
    name: 'policy',
    component: importComponent('Policy')
  },
  {
    path: '/terms',
    name: 'terms',
    component: importComponent('Terms')
  },
  {
    path: '/about',
    name: 'about',
    component: importComponent('AboutView')
  },
  {
    path: '/contact',
    name: 'contact',
    component: importComponent('ContactView')
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})
router.beforeEach(async (to, from, next) => {
  next()
})


export default router
